import { themes } from 'kb-shared';
import * as React from 'react';
import styled from 'styled-components';

import Button from '../../Button/Button';
import { CallToActionBase, CopyBase, TitleBase as Title } from './styled';

const { breakpoints } = themes;

interface CallToActionProps {
  mobile?: boolean;
  onClick?: (e: MouseEvent) => void;
}
const CallToAction = styled(CallToActionBase)`
  overflow: hidden;
  ${(props: CallToActionProps) => (props.mobile && !props.onClick ? 'margin-bottom:25px' : '')};
`;

const Copy = styled(CopyBase)`
  margin-top: 8px;
`;

const IntakeButton = styled(Button)`
  margin: 20px 0px;
  width: 80%;
  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 0;

    ${themes.fonts.FoundersGrotesk};
    background-color: ${themes.colors.night};
    border: ${themes.colors.night};
    color: ${themes.colors.white};
    text-transform: uppercase;
    box-shadow: none;
  }

  @media screen and (min-width: ${breakpoints.tabletPortrait}) {
    width: auto;
    margin: 20px 0px;
  }
`;

const Container = styled.div`
  margin: 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: ${breakpoints.tabletPortrait}) {
    flex-direction: row;
    margin: 20px 0px;
  }
`;

type Props = {
  title: string;
  description: string;
  buttonText?: string;
  onClick?: () => void;
  mobile?: boolean;
  headingText?: string;
};

const ToDoRow = (props: Props) => {
  const { title, description, onClick, mobile, buttonText, headingText } = props;

  function renderDescription() {
    if (description.includes('HIPAA')) {
      return (
        <Copy>
          {description} You can also go to your profile and add trustees who may receive access to
          your medical information.
          <a onClick={e => e.stopPropagation()} href="/my-profile" target="_self">
            {' '}
            <u>Go to profile </u>
          </a>
        </Copy>
      );
    }
    return <Copy>{description}</Copy>;
  }
  return (
    <Container>
      <CallToAction mobile={mobile} onClick={onClick}>
        <Title>{headingText ?? title}</Title>
        {renderDescription()}
      </CallToAction>
      {onClick && <IntakeButton label={buttonText || 'Learn more'} onClick={onClick} />}
    </Container>
  );
};

export default ToDoRow;
